<template>
  <div>
    <v-col cols="12">
      <v-card
        class="pt-5 pb-1 px-2 rounded-lg mt-3"
        elevation="2"
        :style="{
          backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg-dtl)' : 'var(--light-bg-dtl)',
        }"
      >
        <h4 class="text-subtitle-2 font-weight-bold rounded-lg px-3">Pembiayaan</h4>
        <v-divider class="ma-3" style="border-color: #ff9b6a"></v-divider>
        <v-row>
          <v-col v-for="(item, index) in menuItems" :key="index" cols="4" class="text-center">
            <router-link :to="item.route" class="menu-link">
              <v-img :src="item.icon" alt="" contain height="50" class="mx-auto" />
              <p class="text-caption font-weight-bold mt-2">{{ item.label }}</p>
            </router-link>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "Pembiayaan",
  data() {
    return {
      menuItems: [
        { label: "Angsuran", route: "/angsuran/kumpulan", icon: require("@/assets/icon/angsuran.png") },
        { label: "Pengajuan", route: "/pembiayaan/pengajuan", icon: require("@/assets/icon/pengajuan.png") },
        { label: "Pencairan", route: "/pembiayaan/pencairan", icon: require("@/assets/icon/pencairan.png") },
      ],
    };
  },
};
</script>

<style scoped>
.menu-link {
  text-decoration: none;
  color: inherit;
}
</style>
